export default __webpack_public_path__ + "915c50825b5bbb118a2cb7162d75e093.svg";